import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import formatError from "../../services/FormatError";
import {
  addOffer,
  deleteOffer,
  fetchOfferDetails,
} from "../../services/Offers";
import { fetchActiveCurrencies } from "../../services/Currencies";
import { sortList } from "./Users";
import { useTranslation } from "react-i18next";


const validateOfferDetails = (data) => {
  if (data.price !== "" && data.currency !== "" && data.equity !== "") {
    return true;
  }

  return false;
};

const inputDisabled = (update, view) => {
  if (update) {
    return false;
  } else {
    if (view) {
      return true;
    } else {
      return false;
    }
  }
};

const getTag = (update, view,t) => {
  if (update) {
    return t("globalUpdateButton");
  } else {
    if (view) {
      return t("hview");
    } else {
      return t("globalAddButton");
    }
  }
};

function AddOfferPopup({
  show,
  id,
  view,
  offerId,
  onHideOfferModal,
  fetchBusinessList,
  updateCase = false,
}) {
  const { t } = useTranslation();
  
  const [offerDetails, setOfferDetails] = useState({
    price: "",
    currency: "",
    equity: "",
    message: "",
  });

  const [currencyOpt, setCurrencyOpt] = useState([]);

  const [offerTriggered, setOfferTriggered] = useState(false);

  const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (view) {
      getOfferDetails();
    }
  }, [view]);

  useEffect(() => {
    getCurrencies();

    if (updateCase) {
      setUpdate(true);
    }
  }, []);

  const getCurrencies = () => {
    fetchActiveCurrencies()
      .then((res) => {
        const response = res?.data?.result;

        const responseData = response ? sortList(response) : [];

        setCurrencyOpt(responseData);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const getOfferDetails = () => {
    fetchOfferDetails(offerId)
      .then((res) => {
        const response = res?.data?.result;

        setOfferDetails({
          price: response?.price,
          currency: `${response?.currency?.id}`,
          equity: response?.equityoffered,
          message: response?.message,
        });
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateOfferDetails = (key, value) => {
    setOfferDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onAddOfferDetails = (e) => {
    e.preventDefault();

    if (validateOfferDetails(offerDetails)) {
      addOffer(offerId, id, offerDetails)
        .then((res) => {
          setOfferDetails({
            price: "",
            currency: "",
            equity: "",
            message: "",
          });

          setOfferTriggered(false);

          setUpdate(false);

          onHideOfferModal();

          fetchBusinessList();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setOfferTriggered(true);
    }
  };

  const onEditOffer = (e) => {
    e.preventDefault();

    setUpdate(true);
  };

  const onDeleteOffer = (e) => {
    e.preventDefault();

    if (offerId) {
      deleteOffer(offerId)
        .then((res) => {
          setOfferDetails({
            price: "",
            currency: "",
            equity: "",
            message: "",
          });

          setOfferTriggered(false);

          setUpdate(false);

          onHideOfferModal();

          fetchBusinessList();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  return (
    <Modal className="modal fade" show={show} onHide={onHideOfferModal}>
      <div role="document">
        <div>
          <Form>
            <div className="modal-header" style={{color:"#FD7A48"}}>
              <h4 className="modal-title fs-20">
                {getTag(update, view,t)} {t("hoffer")}
              </h4>
              <button
                type="button"
                className="close btn"
                onClick={onHideOfferModal}
              >
                <span>×</span>
              </button>
            </div>

            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>

              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div
                    className={`form-group ${
                      offerTriggered && offerDetails.price === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>{t("hprice")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Price"
                      className="form-control"
                      value={offerDetails.price}
                      onChange={(e) =>
                        updateOfferDetails("price", e.target.value)
                      }
                      disabled={inputDisabled(update, view)}
                    />
                  </div>
                  {offerTriggered && offerDetails.price === "" && (
                    <div className="text-danger fs-12">{t("hpricerequired")}</div>
                  )}

                  <div
                    className={`form-group ${
                      offerTriggered && offerDetails.currency === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>{t("currencyInput")}</strong>
                    </label>
                    <select
                      className="form-control"
                      style={{ border: "1px solid #EEEEEE" }}
                      value={offerDetails.currency}
                      onChange={(e) =>
                        updateOfferDetails("currency", e.target.value)
                      }
                      disabled={inputDisabled(update, view)}
                    >
                      <option value="">{t("globalSelect")}</option>
                      {currencyOpt?.length > 0 &&
                        currencyOpt.map((item) => (
                          <option
                            key={`OfferCurrency${item?.code}`}
                            value={item?.id}
                          >
                            {item?.code}
                          </option>
                        ))}
                    </select>
                  </div>
                  {offerTriggered && offerDetails.currency === "" && (
                    <div className="text-danger fs-12">
                      {t("hcurrencyrequired")}
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      offerTriggered && offerDetails.equity === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>{t("hequity")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Equity"
                      className="form-control"
                      value={offerDetails.equity}
                      onChange={(e) =>
                        updateOfferDetails("equity", e.target.value)
                      }
                      disabled={inputDisabled(update, view)}
                    />
                  </div>
                  {offerTriggered && offerDetails.equity === "" && (
                    <div className="text-danger fs-12">{t("hequityrequired")}</div>
                  )}

                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("hmessage")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Message"
                      className="form-control"
                      value={offerDetails.message}
                      onChange={(e) =>
                        updateOfferDetails("message", e.target.value)
                      }
                      disabled={inputDisabled(update, view)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                style={{ background: "#808080", color: "#fff" }}
                onClick={onHideOfferModal}
              >
                <i className="flaticon-delete-1"></i>
                &nbsp;{t("globalDiscardButton")}
              </button>

              {view ? (
                update ? (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={onAddOfferDetails}
                  >
                    {t("globalUpdateButton")}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onEditOffer}
                  >
                    {t("editButton")}
                  </button>
                )
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={onAddOfferDetails}
                >
                  {t("add")}
                </button>
              )}

              {offerId !== null && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={onDeleteOffer}
                >
                  <i className="flaticon-delete-1"></i>
                  &nbsp;{t("delete")}
                </button>
              )}
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default AddOfferPopup;
